import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl } from 'react-intl';
import ActivityFeed from 'containers/ActivityFeed/ActivityFeed';
import Favorites from 'containers/Favorites/Favorites';
import Recordings from 'components/Recordings/Recordings';
import Welcome from 'containers/Welcome/Welcome';
import { START_ROUTE } from 'constants/StartCallModal';
import classes from './HomeView.module.scss';

class HomeView extends React.PureComponent {
  componentDidMount() {
    this.props.endRouteLoading();
    const route = this.props.match;
    if (!route) return;
    if (route.path === START_ROUTE) {
      this.props.openStartCallModal();
    }
  }

  render() {
    return (
      <div className={classes.horzFlexContainer} id="homeContainer">
        <div className={classes.leftContainer}>
          <Welcome />
        </div>
        {!this.props.isCallConnected ? (
          <div className={classes.rightContainer}>
            <ActivityFeed />
            <Favorites />
            {this.props.recordingsUrl && <Recordings
              recordingsUrl={this.props.recordingsUrl}
            />}
          </div>
        ) : null}
      </div>
    );
  }
}

export default injectIntl(HomeView);

HomeView.propTypes = {
  isCallConnected: PT.bool,
  recordingsUrl: PT.string,
  endRouteLoading: PT.func,
  openStartCallModal: PT.func,
  match: PT.object
};

